
import { css } from 'styled-components';

import { BRAND_COLORS } from './colors';
import { TYPOGRAPHY } from './typography';

export interface FormInputProps {
  $isInvalid?: boolean;
  $isActive?: boolean;
}

const activeInputStyles = css`
  border-color: ${BRAND_COLORS.lightGreen};
`;

export const commonInputStyles = css<FormInputProps>`
  ${TYPOGRAPHY.CIRCULAR.book}
  color: ${BRAND_COLORS.black};
  font-size: 16px;
  line-height: 24px;
  height: 48px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${BRAND_COLORS.stroke};
  background: ${BRAND_COLORS.white};

  transition-property: border-color;
  transition-duration: 100ms;
  transition-timing-function: ease-in-out;

  && {
    ${({ $isActive, $isInvalid }) => $isActive && !$isInvalid && css`
      ${activeInputStyles}
    `}

    &:focus,
    &:focus-within,
    &:focus-visible {
      outline: none;

      /* Only show focus border if valid */
      ${({ $isInvalid }) => !$isInvalid && css`
        ${activeInputStyles}
      `}
    }
  }

  ${({ $isInvalid }) => $isInvalid && css`
    border-color: ${BRAND_COLORS.darkRed};
  `}
`;
